import { GetterTree } from 'vuex';
import { ClaimsState, ClaimPaginator } from './types';
import { RootState } from '@/types';

export const getters: GetterTree<ClaimsState, RootState> = {
    claims(state): ClaimPaginator | undefined {
        const claims  = state.data || undefined;
        return claims;
    },
};
